/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-timeline/content-control-studio-timeline-segment/content-control-studio-timeline-segment.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  align-self: flex-end;
}
img,
svg {
  position: relative;
  left: -5px;
}
/*# sourceMappingURL=content-control-studio-timeline-segment.component.css.map */
